import { useMemo } from 'react';
import { getIn } from 'formik';
import { createValidate, Validation } from './validation';

type FormValidation = Record<string, Validation & { message?: string }>;

export const useFormValidate = (formValidation: FormValidation) =>
  useMemo(() => {
    const validators = Object.entries(formValidation).reduce(
      (fieldValidators, [field, { message, ...validationRules }]) => [
        ...fieldValidators,
        { field, validate: createValidate(validationRules, message) },
      ],
      [] as { field: string; validate: ReturnType<typeof createValidate> }[],
    );

    return (values: Record<string, any>) =>
      validators.reduce(
        (errors, { field, validate }) => ({
          ...errors,
          [field]: validate(getIn(values, field)),
        }),
        {} as Record<string, string | undefined>,
      );
  }, [formValidation]);
